var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuLente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.792,
    height: 22.006,
    viewBox: "0 0 21.792 22.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6970",
    "data-name": "Tracciato 6970",
    d: "M14.586,9.22a8.934,8.934,0,1,1,16.1,5.314l5.293,5.3a1.437,1.437,0,0,1,.4,1.027,1.378,1.378,0,0,1-1.405,1.427,1.48,1.48,0,0,1-1.034-.407l-5.321-5.336a8.864,8.864,0,0,1-5.1,1.612A8.959,8.959,0,0,1,14.586,9.22m15.786,0a6.859,6.859,0,1,0-6.855,6.848A6.893,6.893,0,0,0,30.372,9.22",
    transform: "translate(-14.586 -0.282)",
    fill: "#555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLente);
export default __webpack_public_path__ + "static/media/menu-lente.c8f035319fd7570fbfabf473c24b1dc0.svg";
export { ForwardRef as ReactComponent };